module.exports = __webpack_public_path__ + "media/common/icon-weather-cloudy-daytime-28b372ed.svg";